import React from 'react'

export const Footer = () => {
  return (
    <div className="flex flex-col w-full items-center 
                    bg-slate-200 text-gray-800 
                    dark:bg-slate-900 dark:text-gray-300 
                    transition-colors duration-300">
      <h5 className="text-xl font-semibold">School Management System</h5>
      <p>Copyright © 2025</p>
    </div>
  )
}
